// export function getModuleCheckListToday(state) {
//   let response = []
//   state.checkListDataToday.forEach(element => {
//     if (element.order != "5") {
//       element['img'] = 'modules-0' + element.order
//       response.push(element)
//     }
//   });
//   return response
// }

export function getModuleCheckListPending(state) {
  let response = []
  state.checkListDataPending.forEach(element => {
    if (element.order != "5") {
      element['img'] = 'modules-0' + element.order
      response.push(element)
    }
  });
  return response
}

export function getDataIsGetted(state) {
  return state.dataIsGetted
}

export function getSelectedModId(state) {
  return state.idSelectedModule
}

export function getDataModuleSelected(state) {
  return state.checkListData[state.idSelectedModule]
}

export function getCheckListCriteria(state) {
  return id => {
    let elementToReturn = []
    state.checkListCriteria.forEach(element => {
      if (element.order == id) {
        elementToReturn = element.criteria
      }
    })

    return elementToReturn
  }
}

export function getAllCheckListData(state) {
  return state.checkListData
}

export function getAllCheckListDates(state) {
  return state.checkListDates
}